import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJavaComponent } from './simple-icons-java.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJavaComponent ],
    exports:      [ SimpleIconsJavaComponent ],
    bootstrap:    []
})
export class SimpleIconsJavaModule {}
